import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { NoteState } from "../../context/notes/NoteState";
import { getRoleHomePath } from "../../utils/roleHome";
import { getCachedMenu, pathAllowed } from "../../utils/menuAccessCache";
import "../../App.css";

/**
 * Shown when the user opens a page their role is not allowed to access.
 */
export default function AccessDenied() {
  const navigate = useNavigate();
  const { state } = useContext(NoteState);
  const home = getRoleHomePath(state.role, state.designation_id);
  const cached = getCachedMenu(state.role);
  const allowed = cached?.allowed_paths || [];
  const destination =
    !cached || !allowed.length || pathAllowed(allowed, home) ? home : allowed[0];

  return (
    <div id="unauthorized">
      <div className="section">
        <img
          src="https://cdn.rawgit.com/ahmedhosna95/upload/1731955f/sad404.svg"
          alt="Access denied"
        />
        <h1 className="error mb-3">403</h1>
        <div className="page">
          You don&apos;t have access for this page. Please contact administration.
        </div>
        <button
          type="button"
          className="back-home"
          onClick={() => navigate(destination)}
        >
          Home page
        </button>
      </div>
    </div>
  );
}
